import React, {Component} from 'react';
import PropTypes from "prop-types";
import OperatorTokenEditContainer from "./OperatorTokenEditContainer";
import OperatorTokenOverviewContainer from "./OperatorTokenOverviewContainer";

class OperatorTokenContainer extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
    };

    constructor(props) {

        super(props);

        this.state = {
            activeView: null,
            operatorTokenEdit: null,
        };

        this.translate = this.props.baseData.translate;

        this.changeView = this.changeView.bind(this);

    }

    componentWillReceiveProps(nextProps) {

        this.setState({
            activeView: null
        });

    }

    changeView(activeView = null, operatorTokenEdit = null) {

        this.setState({
            activeView,
            operatorTokenEdit
        });

    }

    renderView() {

        const view = this.state.activeView;

        if (view === 'edit') {
            return <OperatorTokenEditContainer
                baseData={this.props.baseData}
                operatorToken={this.state.operatorTokenEdit}
                changeView={this.changeView}
            />;
        } else {
            return <OperatorTokenOverviewContainer
                baseData={this.props.baseData}
                currentCompany={this.props.baseData.companies.currentCompany}
                changeView={this.changeView}
            />;
        }

    }

    render() {

        const renderedView = this.renderView();

        return (
            <div>
                {renderedView}
            </div>
        );

    }

}

export default OperatorTokenContainer;